<template>
  <div>
    <vs-popup :active.sync="showOtherPaymentMethods" id="otherPayTypesPage">
      <vs-row vs-type="flex" vs-w="12" class="p-0 m-0">
        <vs-button color="transparent" class="payment-label bg-primary2 text-white w-full" icon-pack="feather"
          icon="icon-credit-card">
          Ödeme Seçenekleri
        </vs-button>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="info-row" v-if="activePersonal">
        <vs-col vs-type="flex" class="w-auto">
          <p class="text-primary bold mr-3">
            Personal Adı :
          </p>
          <p class="text-primary">
            {{activePersonal.name}}
          </p>
        </vs-col>
        <vs-col vs-type="flex" class="w-auto ml-auto">
          <p class="text-primary">{{currentDate}}</p>
        </vs-col>
        <vs-col vs-type="flex" class="w-auto ml-3">
          <p class="text-primary">{{currentTime}}</p>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-5">
        <vs-col vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center">
              <img class="responsive w-1/4" src="@/assets/general/payment-method.svg" />
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="center">
              <p class="text-primary" style="font-size:1.4vw!important;font-weight:500;">Lütfen Ödeme Yöntemini
                Seçiniz</p>
            </vs-row>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="p-5" vs-justify="center">
        <vs-col vs-type="flex" class="w-auto margin10 " vs-offset="0.5" v-for="paymentMethod in otherPaymentMethods"
          :key="paymentMethod.id">
          <vs-button @click="setSelectedChildPaymentMethod(paymentMethod);" color="transparent" :class="{'bg-success text-white' : paymentMethod.selected, 'bg-secondary' : !paymentMethod.selected}"
            class="text-primary sale-box-shadow half-friendly-border mr-2 bold" size="large">
            {{paymentMethod.name}}
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
    <vs-button v-show="dontCloseCalc == false || (dontCloseCalc == true && paymentMethod.id != 4)" :disabled="totalPrice == 0" @click="setSelectedPaymentMethod(paymentMethod)" color="transparent"
      v-for="paymentMethod in standartPaymentMethods" :key="paymentMethod.id"
      class="text-white sale-box-shadow half-friendly-border bg-primary mr-2 my-1" size="large"
      :class="{'bg-success' : isSelected(paymentMethod)}">
      {{paymentMethod.name}}
    </vs-button>
    <!--<vs-button @click="showOtherPayTypes = true" color="transparent" v-if="payType.parents!=null && payType.parents.length > 0"-->
    <!--class="text-white sale-box-shadow half-friendly-border bg-primary my-1" size="large"-->
    <!--:class="{'bg-success' : !checkForSelected.standart}">-->
    <!--{{!checkForSelected.standart ? checkForSelected.name : "Diğer"}}-->
    <!--</vs-button>-->
  </div>
</template>

<script>
  export default {
    props: {
      totalPrice: {
        type: Number,
        required: false
      },
      dontCloseCalc: {
        type: Boolean,
        required: false
      },
      currentTime: {
        type: String,
        required: true
      },
      currentDate: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        showOtherPaymentMethods: false,
      };
    },
    computed: {
      activePersonal: function () {
        return this.$store.getters["selfservice/getActivePersonal"];
      },
      paymentMethods: {
        get() {
          return this.$store.getters["selfservice/getPaymentMethods"];
        },
      },
      standartPaymentMethods() {
        return this.$store.getters["selfservice/getPaymentMethods"].filter(x => x.type != 'Single');
      },
      otherPaymentMethods() {
        return this.$store.getters["selfservice/getPaymentMethods"].filter(x => x.originPaymentMethodId == this.$othersPaymentId);
      },
      selectedPaymentMethod: {
        get() {
          return this.$store.getters["selfservice/getSelectedPaymentMethod"];
        },
        set(val) {
          this.$store.dispatch("selfservice/setSelectedPaymentMethod", val);
        }
      }
    },
    watch: {
      showOtherPaymentMethods(val, oldVal) {
        if (oldVal == true && val == false && this.dontCloseCalc == true) {
          this.$emit("dontClose");
        }
      }
    },
    methods: {
      isSelected(method){
        if(method.selected == true || this.paymentMethods.filter(x=> x.originPaymentMethodId == method.id).some(y=> y.selected == true)) return true;
        else return false;
      },
      setSelection(paymentMethod) {
        this.selectedPaymentMethod = paymentMethod;
      },
      setSelectedChildPaymentMethod(paymentMethod) {
        this.setSelection(paymentMethod);
        this.showOtherPaymentMethods = false;
      },

      setSelectedPaymentMethod(method) {
        if (this.paymentMethods.some(x => x.originPaymentMethodId == method.id)) this.showOtherPaymentMethods = true;
        else this.setSelection(method);
      }
    }
  };

</script>

<style>
  .margin10 {
    margin-bottom: 10px !important;
  }
   #otherPayTypesPage .vs-popup .vs-popup--header {
    display: none;
  }

  #otherPayTypesPage .vs-popup .vs-popup--content {
    padding: 0 !important;
    margin: 0 !important;
    width: 100%;
  }

  #otherPayTypesPage .vs-popup {
    border-radius: 2rem !important;
  }

</style>
